






import Vue from 'vue'
import { HistoryItemFinishData } from '@/models/scripts'

interface Props {
  data: HistoryItemFinishData
}

export default Vue.extend<{}, {}, {}, Props>({
  props: {
    data: {
      required: true,
    },
  },
})
